export interface OrganizationSessionState {
  messageBrokerMultiaddr: string | null;
  loadingMessageBrokerMultiaddr: boolean;
  error: string | null;
}

export const initialOrganizationSessionState: OrganizationSessionState = {
  messageBrokerMultiaddr: null,
  loadingMessageBrokerMultiaddr: false,
  error: null,
};
